import {getDefaultStyleFunction} from "@/helpers/ol-style-helper";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {GeoJSON} from "ol/format";

const defaultName = 'selectedFeature'

export function getDefaultName() {
    return defaultName
}

export function createGeoJsonLayer(feature, visible = true, convert = true) {

    const styleFunction = getDefaultStyleFunction()

    const geoJsonObject = generateGeoJsonObjectFromFeature(feature, convert)

    const vectorSource = new VectorSource({
        features: geoJsonObject,
    });

    const vectorLayer = new VectorLayer({
        name: defaultName,
        source: vectorSource,
        style: styleFunction,
        visible: visible,
        zIndex: 30,
    });

    window.map.addLayer(vectorLayer)
}

export function generateGeoJsonObjectFromFeature(feature, convert = true) {
    const geoJson = {}

    geoJson.type = 'FeatureCollection'
    geoJson.features = []
    feature.type = 'Feature'
    geoJson.features.push(feature)

    let options = {}
    if(convert) {
        options = {
            dataProjection: 'EPSG:28992',
            featureProjection: 'EPSG:3857'
        }
    }

    return new GeoJSON(options).readFeatures(geoJson)
}
